'use client'

import * as React from "react"
import { format } from "date-fns"
import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Calendar } from "./calendar"
import { Icons } from "./icons"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./popover"

interface CalendarDatePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  className?: string;
}

export function CalendarDatePicker({ selected, onChange, className }: CalendarDatePickerProps) {
  const handleSelect = (date: Date | undefined) => {
    onChange(date || null);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal",
            !selected && "text-muted-foreground",
            className
          )}
        >
          <Icons.Calendar className="mr-2 h-4 w-4" />
          {selected ? format(selected, "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[200]">
        <Calendar
          mode="single"
          selected={selected || undefined}
          onSelect={handleSelect}
        />
      </PopoverContent>
    </Popover>
  )
}